import { toast } from "react-toastify";

export const EnvHelper = () => ({
    isDebugTheme() { return window.location.host.includes('localhost') }
})

export const toastHelper = ({ message, type, toastId }: { toastId: string, message?: string, type: 'error' | 'info' | 'success' }) => {
    if (toast.isActive(toastId)) {
        toast.update(toastId, { render: message, type });
        return
    }
    toast[type](message, { toastId });
}


export const getEnvHelper = () => {
    const hostname = window.location.hostname;
    const origin = window.location.origin;
    if (hostname === 'localhost' || origin.includes('dev.identitymatrix.ai') || origin.includes('localhost:3000') || origin.includes('app.develop.identitymatrix.ai')) {
        return 'dev';
    }
    if (origin.includes('identitymatrix.ai')) {
        return 'prd';
    }
    return 'unknown';
}
